  <h2 mat-dialog-title>Enter Comment</h2>
    <mat-dialog-content>
      <mat-form-field appearance="fill" class="w-full">
        <textarea matInput placeholder="Comment" [(ngModel)]="comment"></textarea>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="close()">Cancel</button>
      <button mat-raised-button  (click)="submit()" [disabled]="!comment"   style="background-color: #025590; color: white;"
>Submit</button>
    </mat-dialog-actions>